import { ComponentProps, PropsWithChildren } from 'react';
import styles from './link.module.css';

export type LinkButtonProps = ComponentProps<'button'> & {
    preset?: 'primary' | 'secondary';
    onClick?: () => void;
    className?: string;
    style?: React.CSSProperties;
};

export function LinkButton({
    preset = 'primary',
    onClick,
    className,
    style,
    children,
    ...rest
}: PropsWithChildren<LinkButtonProps>) {
    return (
        <button
            type="button"
            className={`${styles.link} ${className} ${preset === 'primary' ? styles.primary : styles.secondary}`}
            style={style}
            onClick={(e) => {
                e.preventDefault();
                if (onClick) {
                    onClick();
                }
            }}
            {...rest}
        >
            {children}
        </button>
    );
}
